const defaultTheme = {
  color1: '#0f4c81',
  color2: '#197ACF',
  color3: '#092F4F',
  color4: '#888',
  color5: '#efefef',
  color6: '#2e394b',

  iconTableColor: '#2e394b',
  iconTableColorHover: '#fad301',

  button: {
    colors: {
      primary: {
        bg: '#fad301',
        font: '#2e394b',
        hoverColor: '#f2dd68',
        hoverFontColor: '#2e394b',
      },
      default: {
        bg: '#2e394b',
        font: '#fff',
        hoverColor: '#41516b',
        hoverFontColor: '#fff',
      },
      clear: {
        bg: '#d6d6d6',
        font: '#0f4c81',
        hoverColor: '#c0c0c0',
        hoverFontColor: '#0f4c81',
      },
      success: {
        bg: '#0a0',
        font: '#fff',
        hoverColor: '#0b0',
        hoverFontColor: '#fff',
      },
      danger: {
        bg: '#ff1f02',
        font: '#fff',
        hoverColor: '#e61a00',
        hoverFontColor: '#fff',
      },
      warning: {
        bg: '#aa0',
        font: '#fff',
        hoverColor: '#990',
        hoverFontColor: '#fff',
      },
      info: {
        bg: '#69f',
        font: '#fff',
        hoverColor: '#58e',
        hoverFontColor: '#fff',
      },
    },
    sizes: {
      small: {
        padding: '0 10px',
        fontSize: '13px',
        height: '24px',
      },
      default: {
        padding: '0 15px',
        fontSize: '14px',
        height: '32px',
      },
      large: {
        padding: '0 20px',
        fontSize: '15px',
        height: '40px',
      },
    },
  },
};

export default defaultTheme;
